<template>
  <div class="container">
    <nav class="work_nav">
      <ul>
        <li
          v-for="(nav, index) in navs"
          :key="index"
          :class="{ active: nav.active }"
        >
          <router-link v-if="nav.isChild" :to="nav.name">{{
            nav.title
          }}</router-link>
          <a v-else @click="goTo(nav.name)">{{ nav.title }}</a>
          <aside v-if="nav.num">{{ nav.num }}</aside>
        </li>
      </ul>
    </nav>
    <div class="work_main">
      <router-view></router-view>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "work-index",
  data() {
    return {
      navs: [
        {
          title: "聊天信息",
          name: "chat-info",
          isChild: 1,
          num: 0,
          active: false,
        },
        {
          title: "平台信息",
          name: "chat-pla",
          isChild: 1,
          num: 0,
          active: false,
        },
        {
          title: "通讯录",
          name: "chat-addbook",
          isChild: 1,
          num: 0,
          active: false,
        },
        {
          title: "客服",
          name: "chat-service",
          isChild: 1,
          num: 0, //消息未读状态
          active: false,
        },

        {
          title: "设置",
          name: "chat-setting",
          isChild: 1,
          num: 0, //消息未读状态
          active: false,
        },
      ],
    };
  },
  created() {
    console.log(this.$route.name);
  },
  methods: {
    goTo(name) {
      let routeData = this.$router.resolve({ name: name });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
  
<style lang="scss" scoped>
.work_nav {
  background: #d9d9d9;
  height: 60px;
    border-radius: 6px;
  overflow: hidden;
  margin-bottom: 19px;

  ul {
    display: flex;
    // justify-content: space-between;

    li {
      position: relative;

      a {
        padding: 0 24px;
        line-height: 60px;
        display: block;
        font-size: 22px;

        &.router-link-active {
          background-color: #4c71db;
          color: #fff;
        }
      }

      aside {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        background-color: #ff4e4e;
        border-radius: 10px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
}

.work_main {
  border-radius: 6px;
  box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
  // padding: 29px 27px;
}
</style>